<template>
    <dialog-lx v-bind.sync="dialogData" @saveClick="saveClick">
        <div class="content-main">
            <div class="dialog-content">
                <div class="content-header">
                    <el-input v-model="inputVal" style="margin: 0 16px;" @keydown.enter.native="seachStudentTableData"
                        :placeholder="$t('teamDetail.QSRXSXM')" size="mini"></el-input>
                    <el-button type="primary" size="mini" @click="seachStudentTableData">{{ $t('teamDetail.CX') }}
                    </el-button>
                </div>
                <div class="table-box">
                    <c-table ref="c-table" :tableData="studentTableData" :ISChangeCheckout="false"
                        @operation="operation" :tableHeader="studentListTableHeader" TableHeight="363px"></c-table>
                </div>
            </div>
        </div>
    </dialog-lx>
</template>
<script>
import dialogLx from '@/components/dialog-lx'
import mins from './mins'
import cTable from '@/components/table'
import fetch from '@/api/fetch'
export default {
    name: 'dialog-add-student',
    components: {
        dialogLx,
        cTable
    },
    mixins: [mins],
    watch: {
        'dialogData.addLxDialog'(newVal) {
            if (newVal) {
                this.inputVal = ''
                this.getStudentList()
            } else {
                this.activeTableData = {}
            }
        }
    },
    methods: {
        getStudentList() {
            fetch.list4Unuse({
                planId: this.planId
            }).then(res => {
                if (res.code == 0) {
                    this.studentTableData = res.data.map((item, index) => ({ index: ++index, ...item }))
                    this.studentTableDataAll = this.studentTableData
                } else {
                    this.$notify({ title: this.$t('teamDetail.operation'), message: res.msg || this.$t('teamDetail.CZSB'), type: 'error' });
                }
            })
        },
        seachStudentTableData() {
            let studentTableData = this.studentTableDataAll.filter(item => item.playerName.indexOf(this.inputVal) != -1)
            this.studentTableData = studentTableData.map((item, index) => ({ ...item, index: ++index }))
        },
        operation(type, rowData) {
            if (type === 'currentChange' && rowData) {
                if (this.$parent.teamData.memberList.findIndex(item => item.playerId === rowData.playerId) != -1) {
                    this.$notify({ title: this.$t('teamDetail.operation'), message: this.$t('teamDetail.DQXSYZTDZ'), type: 'warning' });
                    this.activeTableData = {}
                } else {
                    this.activeTableData = rowData
                }
            }

        },
        saveClick() {
            if (this.activeTableData.playerName) {
                this.dialogData.addLxDialog = false
                this.$emit('saveClick', this.activeTableData)
            } else {
                this.$notify({ title: this.$t('teamDetail.operation'), message: this.$t('teamDetail.QXZYGXSHQR'), type: 'warning' });
            }
        }
    }
}
</script>
<style scoped lang="scss">
.content-header {
    /deep/ .el-input {
        width: 260px;
        height: 32px;
        border-radius: 2px;

        /deep/ .el-input__inner {
            background: #F1F2F4;
        }
    }

}
</style>